import I18n from 'I18n';
import { useState, useMemo, useCallback, useContext } from 'react';
import updateFormFieldKey from 'forms-utils-lib/formField/utils/updateFormFieldKey';
import FormFieldKeys from 'forms-utils-lib/constants/formField/FormFieldKeys';
import TrackingContext from 'ui-forms-components/contextProviders/TrackingContext';
import { FIELD_OPTIONS } from 'ui-forms-components/constants/TrackingEvents';
import { SortAlpAscIcon } from 'foundations-assets/icons/components/SortAlpAscIcon';
import { SortAlpDescIcon } from 'foundations-assets/icons/components/SortAlpDescIcon';
var SortStates;
(function (SortStates) {
  SortStates[SortStates["UNSORTED"] = 0] = "UNSORTED";
  SortStates[SortStates["ASC"] = 1] = "ASC";
  SortStates[SortStates["DESC"] = 2] = "DESC";
})(SortStates || (SortStates = {}));
const ASCENDING_ICON = SortAlpAscIcon;
const DESCENDING_ICON = SortAlpDescIcon;
const useSortFormFieldOptions = (formField, handleUpdate) => {
  const [sortState, setSortState] = useState(SortStates.UNSORTED);
  const {
    track
  } = useContext(TrackingContext);
  const locale = I18n.locale;
  const nextState = useMemo(() => sortState === SortStates.UNSORTED || sortState === SortStates.DESC ? SortStates.ASC : SortStates.DESC, [sortState]);
  const NextStateIcon = useMemo(() => nextState === SortStates.ASC ? ASCENDING_ICON : DESCENDING_ICON, [nextState]);
  const handleSort = useCallback(() => {
    const newOptions = nextState === SortStates.ASC ? formField.options.sort(({
      label: labelA
    }, {
      label: labelB
    }) => labelA.localeCompare(labelB, locale)) : formField.options.sort(({
      label: labelA
    }, {
      label: labelB
    }) => labelB.localeCompare(labelA, locale));
    handleUpdate(updateFormFieldKey(formField, FormFieldKeys.OPTIONS, newOptions));
    setSortState(nextState);
    track(FIELD_OPTIONS.SORTED);
  }, [formField, handleUpdate, nextState, locale, track]);
  return useMemo(() => ({
    NextStateIcon,
    handleSort
  }), [NextStateIcon, handleSort]);
};
export default useSortFormFieldOptions;